export const PRINT_FILTER = "Print Editions";
export const PRINT_SHIPPING = 7;

export const PRINT_EDITIONS = {
  "work-01": {
    lookupKey: "love_quetee_print_work_01",
    dimensions: "5 × 7 in",
    price: 20,
    priceLabel: "$20 USD",
    badge: "Print 5 × 7 · $20",
  },
  "work-02": {
    lookupKey: "love_quetee_print_work_02",
    dimensions: "8 × 10.5 in",
    price: 30,
    priceLabel: "$30 USD",
    badge: "Print 8 × 10.5 · $30",
  },
  "work-03": {
    lookupKey: "love_quetee_print_work_03",
    dimensions: "5 × 7 in",
    price: 20,
    priceLabel: "$20 USD",
    badge: "Print 5 × 7 · $20",
  },
  "work-04": {
    lookupKey: "love_quetee_print_work_04",
    dimensions: "8 × 10.5 in",
    price: 30,
    priceLabel: "$30 USD",
    badge: "Print 8 × 10.5 · $30",
  },
  "work-05": {
    lookupKey: "love_quetee_print_work_05",
    dimensions: "8 × 10.5 in",
    price: 30,
    priceLabel: "$30 USD",
    badge: "Print 8 × 10.5 · $30",
  },
  "work-06": {
    lookupKey: "love_quetee_print_work_06",
    dimensions: "5 × 7 in",
    price: 20,
    priceLabel: "$20 USD",
    badge: "Print 5 × 7 · $20",
  },
  "work-07": {
    lookupKey: "love_quetee_print_work_07",
    dimensions: "5 × 7 in",
    price: 20,
    priceLabel: "$20 USD",
    badge: "Print 5 × 7 · $20",
  },
};

export const getPrintEdition = (workId) => PRINT_EDITIONS[workId] || null;
